import client from '../client';
import type { Complaint } from '../../types/complaint';
import type { ApiResponse, PaginationParams } from '../../types/api';

export const complaintsApi = {
  list: async (storeId: string, params?: PaginationParams & { status?: string; priority?: string }) => {
    const res = await client.get<ApiResponse<{ complaints: Complaint[]; pagination: { page: number; limit: number; total: number; pages: number } }>>(
      `/dashboard/${storeId}/complaints`,
      { params },
    );
    return res.data.data!;
  },

  get: async (storeId: string, complaintId: string) => {
    const res = await client.get<ApiResponse<{ complaint: Complaint }>>(
      `/dashboard/${storeId}/complaints/${complaintId}`,
    );
    return res.data.data!;
  },

  update: async (storeId: string, complaintId: string, data: { status?: string; resolution?: string }) => {
    await client.patch(`/dashboard/${storeId}/complaints/${complaintId}`, data);
  },

  delete: async (storeId: string, complaintId: string): Promise<void> => {
    await client.delete(`/dashboard/${storeId}/complaints/${complaintId}`);
  },
};
